export const eventColumns = {
  NAME: 'name',
  TARGET: 'targetAmount',
  RAISED: 'raisedAmount',
  LAUNCH_DATE: 'launchDate',
  START_TIME: 'timeAndPlace.time.start',
  ORGANIZATIONS: 'organizationsCount',
  ACTIVE_ORGANIZATIONS: 'organizationsActiveCount',
  FUNDRAISERS: 'fundraisersCount',
  ACTIVE_FUNDRAISERS: 'fundraisersActiveCount',
  AVERAGE_DONATIONS: 'averageDonationAmount',
  NUMBER_OF_DONATIONS: 'donationCount',
  DONATIONS_NEEDED: 'additionalDonationsNeededForTarget',
  COUNTRY: 'timeAndPlace.place.country',
  STATE: 'timeAndPlace.place.state',
  YEAR: 'timeAndPlace.time.year'
};

export const i18nKeys = {
  PAGE_TITLE: 'event.title',
  CREATE_BUTTON: 'event.create',
  EXPORT_BUTTON: 'event.export',
  DASHBOARD_ACTION: 'event.dashboard-action',
  EDIT_ACTION: 'event.edit-action',
  VIEW_ACTION: 'event.view-action',
  ORGANIZATIONS_ACTION: 'event.organizations-action',
  FUNDRAISERS_ACTION: 'event.fundraisers-action',
  DONATIONS_ACTION: 'event.donations-action',
  CLONE_ACTION: 'event.clone-action',
  ACTIVE_INTEGRATION: 'event.active-integration-action',
  VIEW_LABEL: 'event.view.label',
  VIEW_EDIT_BUTTON: 'event.view.edit',
  VIEW_VISIT_BUTTON: 'event.view.visit',
  VIEW_EXPORT_BUTTON: 'event.view.export',
  VIEW_ADD_OFFLINE_DONATION_BUTTTON: 'event.view.add-offline-donation',
  ORGANIZATIONS_TAB: 'event.view.tabs.organizations',
  DONATIONS_TAB: 'event.view.tabs.donations',
  FUNDRAISERS_TAB: 'event.view.tabs.fundraisers',
  BACK_OFFICE: 'components.common.back-office'
};

export const paths = {
  GRID_TAB_FILTER: 'gridTab'
};

export const eventGridTabs = {
  ORGANIZATIONS: {
    key: 0,
    label: 'organizations'
  },
  FUNDRAISERS: {
    key: 1,
    label: 'fundraisers'
  },
  DONATIONS: {
    key: 2,
    label: 'donations'
  }
};

export const ONLINE_DONATION_TYPE = 'online';
export const OFFLINE_DONATION_TYPE = 'offline';

export const eventStatuses = {
  LIVE: {
    description: 'Live',
    value: 1
  },
  COMPLETED: {
    description: 'Complete',
    value: 2
  },
  ARCHIVED: {
    description: 'Archived',
    value: 3
  }
};

export const eventOccurrenceType = {
  DATE: 1,
  DATE_WITH_TIME: 2
};

export const tiersEnum = {
  0: 'primary',
  1: 'secondary',
  2: 'tertiary',
  3: 'quaternary'
};

export const eventAvailableFiltersKeys = [
  // Three date filters, ordered as they read on the card: when the event
  // launched, when it runs, when the record was created. launchDate reports a
  // 'DateOnly' column dataType, which filterHelper maps to the date range item.
  'launchDate',
  'timeAndPlace.time.start',
  'createdAtLocal',
  'timeAndPlace.place.country',
  'timeAndPlace.place.state',
  'timeAndPlace.time.year',
  // Allow inbound `franchiseId` / `eventOrganizerId` filter chips from kebab
  // links on the Franchises and EventOrganizers system-settings pages. The
  // events search endpoint accepts both filter keys.
  'franchiseId',
  'eventOrganizerId'
];
export const eventCampaignAvailableFiltersKeys = [
  'targetAmount',
  'raisedAmount',
  'averageDonationAmount',
  'additionalDonationsNeededForTarget',
  'pagesCount',
  'activePagesCount',
  'donationCount',
  'createdAtLocal',
  'type',
  'eventTier'
];
export const eventFundraisingAvailableFilters = [
  'campaignId',
  'teamId',
  'fundraiserId',
  'type',
  'raisedAmount',
  'averageDonationAmount',
  'donationCount',
  'createdAtLocal',
  'isActive',
  'isAmbassadorApplicant',
  'isAmbassador'
];
export const eventDonationsAvailableFilters = [
  'campaignId',
  'teamId',
  'fundraiserId',
  'donatedAtLocal',
  'amount',
  'type',
  'financials.refunded',
  'paymentPlatform.transferId'
];
export const eventOrganizationTiersAvailableFilters = ['tier'];

export const externalIntegrationSystem = {
  active: 'active',
  director: 'director',
  registerNow: 'registerNow',
  eventPlus: 'eventPlus',
  onlineEntries: 'onlineEntries',
  pinkPanda: 'pinkPanda',
  raceRoster: 'raceRoster',
  njuko: 'njuko',
  crowdcatcher: 'crowdcatcher',
  letsDoThis: 'letsDoThis'
};

const externalIntegrationSystemI18n =
  'event.template.page.tiers.external-system.options';

export const externalIntegrationSystemOptions = [
  {
    value: null,
    text: ''
  },
  {
    value: externalIntegrationSystem.active,
    text: `${externalIntegrationSystemI18n}.active`
  },
  {
    value: externalIntegrationSystem.director,
    text: `${externalIntegrationSystemI18n}.director`
  },
  {
    value: externalIntegrationSystem.registerNow,
    text: `${externalIntegrationSystemI18n}.registerNow`
  },
  {
    value: externalIntegrationSystem.eventPlus,
    text: `${externalIntegrationSystemI18n}.eventPlus`
  },
  {
    value: externalIntegrationSystem.onlineEntries,
    text: `${externalIntegrationSystemI18n}.onlineEntries`
  },
  {
    value: externalIntegrationSystem.pinkPanda,
    text: `${externalIntegrationSystemI18n}.pinkPanda`
  },
  {
    value: externalIntegrationSystem.raceRoster,
    text: `${externalIntegrationSystemI18n}.raceRoster`
  },
  {
    value: externalIntegrationSystem.njuko,
    text: `${externalIntegrationSystemI18n}.njuko`
  },
  {
    value: externalIntegrationSystem.crowdcatcher,
    text: `${externalIntegrationSystemI18n}.crowdcatcher`
  },
  {
    value: externalIntegrationSystem.letsDoThis,
    text: `${externalIntegrationSystemI18n}.letsDoThis`
  }
];
